export const userSchedule = {
  "main": {
    "title": "Agenda de usuarios",
    "snackbars": {
      "closeSuccess": "La visita se cerró exitosamente",
      "itWasAError": "Ocurrió un error al cerrar la visita",
      "descriptionClose": "Una vez se cierre la visita ya no se podrá iniciar o editar"
    }
  },
  "userSelect":"Selección de usuario",
  "referenceStore":"Unidad de referencia",
  "detail": {
    "tables": {
      "fullname": "Nombres y apellidos",
      "curp": "CURP",
      "userType": "Tipo de usuario",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "store": 'Unidad',
      "questionnaireName": "Nombre del cuestionario",
      "questionnaire": "Cuestionario",
      "askAmount": "# Preguntas",
      "actionPlan": "Plan de acción",
      "appAmount": "# De aplicaciones",
      "status": "Estatus",
      "user": "Usuario asignado",
      "dateAndApplicated": "Fecha de aplicación",
      "fromTo": "Desde DD/MM/YY a las HH:MM hasta DD/MM/YY a las HH:MM",
      "frequency": "Frecuencia",
      "availabilitiesScheduled": "Planificaciones disponibles",
    },
    "errors": {
      "invalidaDtae": "La fecha no es válida",
      "minimus0minute": "La fecha de inicio debe ser mayor o igual a la fecha actual",
      "minimus5minute": "La fecha de fin debe ser al menos 5 minutos mayor a la fecha de inicio",
      "currentDateIsNotValidate": "La fecha de fin debe ser mayor a la fecha actual",
      "wrongDates": "Todas las visitas tienen fechas invalidas",
      "someDatesAreExpired": "Se encontraron planificaciones con fechas inválidas",
      "wasAnErrorCreated": "Ocurrió un error en creación de la visita",
      "wasAnErrorUpdated": "Ocurrió un error en actualización de la visita",
      "someScheduledWereNotCreated": "No todas las visitas fueron creadas",
      "scheduleWereCreated": "Las visitas se crearon exitosamente",
      "scheduleWereUpdated": "La visita se actualizó exitosamente",
      "doYouWantToCreateTheSchedule": "¿Quieres continuar con la asignación de las agendas?",
      "someScheduleWereNotSelected": "Algunos de los agendamientos no se seleccionaron"
    },
    "buttons": {
      "applySelected": "Aplicar al registro seleccionado",
      "applySelectedToAll": "Aplicar a todos los registros",
      "apply" : "Aplicar",
      "cancel": "Cancelar",
      "selectOtherUser": "Seleccionar otro usuario",
      "user":"Usuario"
    },
    "snackbar": {
      "docName": "Agenda de usuarios"
    },
    "steps": {
      "1": "Usuarios",
      "2": "Cuestionarios",
      "3": "Disponibilidad"
    }
  }
}